import type { DifficultyChip } from '@alltrails/types/DifficultyChip';
import type { DifficultyChipUid } from '@alltrails/types/DifficultyChipUid';
import type DifficultyChips from '@alltrails/core/types/DifficultyChips';

/**
 * Maps difficulty chip UIDs to actual DifficultyChip objects for reviews.
 *
 * @param reviews - Array of reviews that may have difficultyChipUids
 * @param difficultyChips - DifficultyChips object containing all available chips
 * @returns Array of reviews with difficultyChips populated
 */
export default function mapDifficultyChips<T = any>(reviews: T[], difficultyChips: DifficultyChips | null | undefined): T[] {
  if (!difficultyChips) {
    return reviews;
  }

  const allChips = Object.values(difficultyChips).flat();

  return reviews.map((review: any) => {
    if (review.difficultyChips && review.difficultyChips.length > 0) {
      return review;
    }

    if (!review.difficultyChipUids || review.difficultyChipUids.length === 0) {
      return review;
    }

    const chips: DifficultyChip[] = review.difficultyChipUids
      .map((uid: DifficultyChipUid) => allChips.find(chip => chip.uid === uid))
      .filter((chip): chip is DifficultyChip => chip !== undefined);

    return {
      ...review,
      difficultyChips: chips
    };
  });
}
